// extracted by mini-css-extract-plugin
export default {"content-container":"PopupModifyCartItem_content-container__88l5f","image":"PopupModifyCartItem_image__q31NQ"};